function AnalyticsClient (projectId) {
  this.projectId = projectId
}

AnalyticsClient.prototype.track = function (action, label, value) {
  const options = {
    'event': 'graphics_event',
    'eventCategory': 'graphics-' + this.projectId,
    'eventAction': action
  }
  if (label) options['eventLabel'] = JSON.stringify(label)
  if (value) options['eventValue'] = value

  window.dataLayer.push(options)
  if (process.env.NODE_ENV !== 'production') {
    console.log([
      'GA tracking event',
      '  action: ' + action,
      '  label: ' + options['eventLabel'],
      '  value: ' + options['eventValue']
    ].join('\n'))
  }
}

AnalyticsClient.prototype.tracker = function (action, label) {
  return this.track.bind(this, action, label)
}

AnalyticsClient.prototype.time = function (action, label) {
  const start = Date.now()
  const track = this.track.bind(this, action, label)
  return function () {
    const elapsed = (Date.now() - start) / 1000
    track(Math.round(elapsed))
  }
}

module.exports = AnalyticsClient
